// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/components/PaymentRedirect.css */

.redirect-container {
    text-align: center;
    margin-top: 100px;
  }
  
  .redirect-container h2 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  .redirect-container p {
    font-size: 16px;
    color: #555;
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/Payments/PaymentRedirect/PaymentRedirect.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;IACI,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;EACb","sourcesContent":["/* frontend/src/components/PaymentRedirect.css */\n\n.redirect-container {\n    text-align: center;\n    margin-top: 100px;\n  }\n  \n  .redirect-container h2 {\n    font-size: 24px;\n    margin-bottom: 10px;\n  }\n  \n  .redirect-container p {\n    font-size: 16px;\n    color: #555;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
